import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { I18nProvider } from "./contexts/I18nContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import CookieConsent from "./components/CookieConsent";
import { registerServiceWorker, attachInstallPromptHandler } from "./lib/pwa";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AuthCallback from "./pages/AuthCallback";
import GoogleCallback from "./pages/GoogleCallback";
import TrainerSearch from "./pages/TrainerSearch";
import TrainerDetail from "./pages/TrainerDetail";
import BookingFlow from "./pages/BookingFlow";
import PaymentSuccess from "./pages/PaymentSuccess";
import SessionLive from "./pages/SessionLive";
import LearnerDashboard from "./pages/LearnerDashboard";
import TrainerDashboard from "./pages/TrainerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import CbtPractice from "./pages/CbtPractice";
import LegalPage from "./pages/LegalPage";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Auth callback in URL hash
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/google" element={<GoogleCallback />} />
        <Route path="/trainers" element={<TrainerSearch />} />
        <Route path="/trainers/:id" element={<TrainerDetail />} />
        <Route path="/booking/:id" element={<ProtectedRoute><BookingFlow /></ProtectedRoute>} />
        <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/session/:id" element={<ProtectedRoute><SessionLive /></ProtectedRoute>} />
        <Route path="/learner" element={<ProtectedRoute role="learner"><LearnerDashboard /></ProtectedRoute>} />
        <Route path="/trainer" element={<ProtectedRoute role="trainer"><TrainerDashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute role={["admin", "subadmin"]}><AdminDashboard /></ProtectedRoute>} />
        <Route path="/cbt" element={<ProtectedRoute role="learner"><CbtPractice /></ProtectedRoute>} />
        <Route path="/privacy" element={<LegalPage title="Privacy Policy" slug="privacy" />} />
        <Route path="/terms" element={<LegalPage title="Terms of Service" slug="terms" />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  useEffect(() => {
    document.title = "DriveTerrain · Canada's verified driving trainer marketplace";
    registerServiceWorker();
    attachInstallPromptHandler(() => {});
  }, []);
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <AppRouter />
          <CookieConsent />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
